import api from './api';

export type StatusRotacao = 'rascunho' | 'ativa' | 'terminada' | 'cancelada';
export type StatusSlot = 'pendente' | 'ativa' | 'terminada' | 'cancelada';
export type CategoriaSlot = 'food' | 'shop' | 'events' | 'parceiros' | 'custom';

export interface RotacaoSlot {
  id: number;
  id_rotacao: number;
  semana_num: number;
  titulo: string;
  categoria: CategoriaSlot;
  percentagem: number;
  budget_semana: number | null;
  eligible_merchants: any;
  eligible_categories: any;
  data_inicio: string;
  data_fim: string;
  status: StatusSlot;
  generated_campaign_id: number | null;
}

export interface Rotacao {
  ID_ROTACAO: number;
  NOME: string;
  DESCRICAO: string | null;
  STATUS: StatusRotacao;
  DATA_INICIO: string;
  NUM_SEMANAS: number;
  BUDGET_TOTAL: number | null;
  CREATED_AT: string;
  total_slots?: number;
  slots_ativos?: number;
  slots?: RotacaoSlot[];
}

export interface CreateRotacaoPayload {
  nome: string;
  descricao?: string;
  data_inicio: string;
  num_semanas?: number;
  budget_total?: number;
  slots?: Array<{
    semana_num: number;
    titulo: string;
    categoria: CategoriaSlot;
    percentagem: number;
    budget_semana?: number;
  }>;
}

class MarketingRotacaoService {
  async setup() {
    await api.post('/admin/marketing/rotacao/setup');
  }
  async list(): Promise<Rotacao[]> {
    const res = await api.get('/admin/marketing/rotacao');
    return res.data.data || [];
  }
  async get(id: number): Promise<Rotacao> {
    const res = await api.get(`/admin/marketing/rotacao/${id}`);
    return res.data.data;
  }
  async create(payload: CreateRotacaoPayload): Promise<Rotacao> {
    const res = await api.post('/admin/marketing/rotacao', payload);
    return res.data.data;
  }
  async update(id: number, payload: Partial<CreateRotacaoPayload & { status: StatusRotacao }>) {
    await api.put(`/admin/marketing/rotacao/${id}`, payload);
  }
  async remove(id: number) {
    await api.delete(`/admin/marketing/rotacao/${id}`);
  }
  async updateSlot(id: number, slotId: number, payload: Partial<RotacaoSlot>) {
    await api.put(`/admin/marketing/rotacao/${id}/slots/${slotId}`, payload);
  }
  async deleteSlot(id: number, slotId: number) {
    await api.delete(`/admin/marketing/rotacao/${id}/slots/${slotId}`);
  }
  async activateSlot(id: number, slotId: number): Promise<{ campaign_id: number }> {
    const res = await api.post(`/admin/marketing/rotacao/${id}/slots/${slotId}/activate`);
    return res.data.data;
  }
  async endSlot(id: number, slotId: number) {
    await api.post(`/admin/marketing/rotacao/${id}/slots/${slotId}/end`);
  }
}

export default new MarketingRotacaoService();
